import { Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'sonner'
import { LoginPage } from './pages/Login'
import { CalendarPage } from './pages/Calendar'
import { ClientsPage } from './pages/Clients'
import { ServicesPage } from './pages/Services'
import { RoomsPage } from './pages/Rooms'
import { StaffPage } from './pages/Staff'
import { PackagesPage } from './pages/Packages'
import { GiftCardsPage } from './pages/GiftCards'
import { PaymentsPage } from './pages/Payments'
import { ReportsPage } from './pages/Reports'
import { SettingsPage } from './pages/Settings'
import { AppLayout } from './layout/AppLayout'
import { useAuth } from './contexts/AuthContext'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth()
  
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-600 border-t-transparent" />
      </div>
    )
  }
  
  return user ? <>{children}</> : <Navigate to="/login" replace />
}

function PublicRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth()
  
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-600 border-t-transparent" />
      </div>
    )
  }
  
  return user ? <Navigate to="/app/calendar" replace /> : <>{children}</>
}

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
        <Route
          path="/app/*"
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="calendar" replace />} />
          <Route path="calendar" element={<CalendarPage />} />
          <Route path="clients" element={<ClientsPage />} />
          <Route path="services" element={<ServicesPage />} />
          <Route path="rooms" element={<RoomsPage />} />
          <Route path="staff" element={<StaffPage />} />
          <Route path="packages" element={<PackagesPage />} />
          <Route path="gift-cards" element={<GiftCardsPage />} />
          <Route path="payments" element={<PaymentsPage />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
      <Toaster position="top-right" toastOptions={{ duration: 4000 }} />
    </>
  )
}